<template>
    <div v-show="editAble||upload.fileList.length!=0">
        <el-upload
                :limit="limit"
                :accept="accept"
                :action="upload.url"
                :headers="upload.headers"
                :list-type="listType"
                name="file"
                :multiple="false"
                :data="initParam"
                :file-list="upload.fileList"
                :on-progress="handleFileUploadProgress"
                :before-upload="handleFileBeforeUploadSuccess"
                :on-success="handleFileSuccess"
                :on-exceed="handleExceed"
                :before-remove="handleDelete"
                :on-preview="handleDownload"
                :auto-upload="true"
                :disabled="!editAble">
            <template v-if="editAble">
                <i v-if="listType=='picture-card'" slot="default" class="el-icon-plus"></i>
                <el-button v-if="listType=='text'" icon="el-icon-upload" slot="trigger" size="mini" type="primary"
                           :loading="upload.isUploading">附件上传
                </el-button>
                <span slot="tip" class="el-upload__tip" style="color:#999999;margin-left:10px;">附件格式为{{accept}}，最多只能上传{{limit}}个文件。</span>
                <!--color:#F56C6C;-->
            </template>
        </el-upload>
    </div>
</template>
<script>
    import {getToken} from "@/utils/auth";
    import {
        listAttachmentNoPage,
        getAttachment,
        delAttachment,
        addAttachment,
        updateAttachment
    } from "@/api/system/attachment";

    export default {
        name: 'AttachmentList',
        props: {
            module: {
                type: String,
                required: true
            },
            businessid: {
                type: String,
                required: true
            },
            editAble: {
                type: Boolean,
                default: true
            },
            listType: {
                type: String,
                default: 'text'
            },
            limit: {
                type: Number,
                default: 1
            },
            accept: {
                type: String,
                default: '.pdf'
            },
            size: {
                type: Number,
                default: 300
            },
        },
        data() {
            return {
                loading: false,
                // 上传参数
                upload: {
                    // 是否禁用上传
                    isUploading: false,
                    // 设置上传的请求头部
                    headers: {
                        // Authorization: "Bearer " + getToken()
                    },
                    // 上传的地址
                    url: process.env.VUE_APP_BASE_API + "/web/attachment/upload",
                    // 上传的文件列表
                    fileList: []
                },
                remSize: 1024*300,
            }
        },
        computed: {//将参数转化成计算属性
            initParam() {
                return {
                    module: this.module,
                    businessid: this.businessid,
                    limit: this.limit,
                    accept: this.accept,
                    size: this.size,
                }
            }
        },
        watch: {//监听计算属性变化
            initParam: {
                handler(val) {
                    //值变化是初始化
                    this.initAttachment();
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            //初始化附件列表
            initAttachment() {
                this.getList();
            },
            //查询附件列表
            getList() {
                this.upload.isUploading = true;
                this.upload.fileList = [];
                listAttachmentNoPage(this.initParam).then(response => {
                    this.upload.isUploading = false;
                    this.$emit('isEmitFun', response.data.length);
                    for (let temp of response.data) {
                        this.upload.fileList.push({
                            ...temp,
                            name: temp.fileName,
                            url: temp.path
                        });
                    }
                });
            },
            // 文件上传中处理
            handleFileUploadProgress(event, file, fileList) {
                let countSize = 0;
                fileList.pop();
                for (let temp of fileList){
                    countSize=temp.attachmentSize+countSize
                }
                this.remSize = this.size*1024-countSize;
                fileList.push(file)
                this.upload.isUploading = true;
            },
            // 文件上传成功前处理
            handleFileBeforeUploadSuccess(file) {
                let judgeSizeResult = file.size/1024<this.remSize?'1':'0';
                if (judgeSizeResult==='0'){
                    this.$message({
                        message:'上传文件总大小不能大于50M！',
                        type: 'error'
                    })
                    return false;
                }else {
                    return true;
                }
            },
            // 文件上传成功处理
            handleFileSuccess(response, file, fileList) {
                this.upload.isUploading = false;
                if (response.code == 200) {
                    this.msgSuccess(response.msg);
                    for (let temp of fileList) {
                      // console.log("fileList",fileList)
                        if (temp.uid == file.uid) {
                            Object.assign(temp, response.data);
                        }
                    }
                    this.$emit('isEmitFun', fileList.length);
                } else {
                    this.msgError(response.msg);
                }
            },
            //文件超出个数限制
            handleExceed(files, fileList) {
                this.msgError(`最多只能上传${this.limit}个文件！`);
            },
            // 删除按钮操作
            handleDelete(file, fileList) {
                if (file.fileName!=undefined){
                    let fileIds = file.fileId;
                    return this.$confirm('是否确认删除' + file.fileName + '附件?', "警告", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(function () {
                        return delAttachment(fileIds);
                    }).then(() => {
                        this.msgSuccess("删除成功");
                        this.$emit('isEmitFun', fileList.length-1);
                    }).catch(function () {
                        reject(false);
                    });
                }else {
                    fileList.pop();
                    return false;
                }
            },
            handleDownload(file) {
                var name = file.fileName;
                var url = file.path;
                const a = document.createElement('a');
                a.setAttribute('download', name);
                a.setAttribute('target', '_blank');
                a.setAttribute('href', process.env.VUE_APP_BASE_API + url);
                a.click();
            },
        }
    }
</script>
<style scoped>
    .attachment-title {
        line-height: 30px;
        font-size: 14px;
    }
</style>
